export const isMatchingExtension = (file: File, extensions: string) => {
  const split = file.name.split(".");

  //handle files without extension
  if (split.length == 1) {
    return false;
  }

  const extension = split.pop();
  if (!extension) {
    return false;
  }
  return extensions.includes(extension);
};
